(function (scope) {
  'use strict';
  var supported = ['en', 'de', 'fr'];
  var manualKey = 'mg-language-preference-v1';
  var attemptKey = 'mg-language-default-attempt-v1';

  function isSupported(value) { return supported.indexOf(value) !== -1; }
  function countryLanguage(country, browserLanguage) {
    return country === 'DE' ? 'de' : country === 'FR' ? 'fr' :
      country === 'CA' && /^fr(?:-|$)/i.test(browserLanguage || '') ? 'fr' : 'en';
  }
  function excludedPath(path) {
    return /^\/(?:de|fr)(?:\/|$)/.test(path) ||
      /^\/(?:cart|checkout|checkouts|account|customer_authentication|admin)(?:\/|$)/.test(path);
  }
  function chooseLanguage(current, available, manual, country, browserLanguage) {
    var target = isSupported(manual) ? manual : countryLanguage(country, browserLanguage);
    return available.indexOf(target) !== -1 && target !== current ? target : null;
  }
  function detectedCountry(response) {
    var country = response && response.detected_values && response.detected_values.country;
    var value = country && country.handle;
    return typeof value === 'string' && /^[A-Z]{2}$/.test(value) ? value : null;
  }

  // Keep the routing decision testable without a browser or a Shopify session.
  if (typeof module === 'object' && module.exports) {
    module.exports = { countryLanguage: countryLanguage, excludedPath: excludedPath,
      chooseLanguage: chooseLanguage, detectedCountry: detectedCountry };
    return;
  }
  var document = scope.document;
  var node = document.getElementById('mg-language-default-config');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (error) { return; }
  var available = (config.languages || []).filter(isSupported);
  var interacted = false;
  function readManual() {
    try { var value = scope.localStorage.getItem(manualKey); return isSupported(value) ? value : null; }
    catch (error) { return null; }
  }
  function saveManual(value) {
    if (!isSupported(value)) return;
    interacted = true;
    try { scope.localStorage.setItem(manualKey, value); } catch (error) { /* Native form still works. */ }
  }
  // Capture runs before the header's native onchange form.submit().
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && (input.name === 'locale_code' || input.name === 'language_code')) saveManual(input.value);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id === 'MGLanguageDefaultForm' || !form.querySelector) return;
    var input = form.querySelector('[name="locale_code"], [name="language_code"]');
    if (input) saveManual(input.value);
  }, true);

  if (!config.active || available.length < 2 || excludedPath(scope.location.pathname) ||
      (scope.Shopify && scope.Shopify.designMode) ||
      /bot|crawler|spider|slurp|facebookexternalhit|preview/i.test(scope.navigator.userAgent)) return;
  document.addEventListener('pointerdown', function () { interacted = true; }, { capture: true, once: true });
  document.addEventListener('keydown', function () { interacted = true; }, { capture: true, once: true });

  function apply(target) {
    if (!target || interacted || excludedPath(scope.location.pathname)) return;
    var form = document.getElementById('MGLanguageDefaultForm');
    var language = document.getElementById('MGDefaultLocaleCode');
    var returnTo = document.getElementById('MGDefaultReturnTo');
    if (!form || !language || !returnTo || form.querySelector('[name="country_code"]')) return;
    var attempt = scope.location.pathname + '|' + target;
    try {
      if (scope.sessionStorage.getItem(attemptKey) === attempt) return;
      scope.sessionStorage.setItem(attemptKey, attempt);
    } catch (error) { return; } // No storage: do not risk a localization loop.
    language.value = target;
    var destination = scope.location.pathname + scope.location.search + scope.location.hash;
    form.querySelectorAll('[name="return_to"]').forEach(function (input) { input.value = destination; });
    form.submit();
  }
  var manual = readManual();
  if (manual) {
    apply(chooseLanguage(config.current, available, manual, null));
    return;
  }
  if (!scope.fetch || !scope.AbortController) return;
  var controller = new scope.AbortController();
  var timeout = scope.setTimeout(function () { controller.abort(); }, 2000);
  var root = typeof config.root === 'string' ? config.root : '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  scope.fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
    credentials: 'same-origin', signal: controller.signal
  }).then(function (response) {
    if (!response.ok) throw new Error('Localization unavailable');
    return response.json();
  }).then(function (response) {
    var country = detectedCountry(response);
    var browserLanguage = String((scope.navigator.languages || [scope.navigator.language])[0] || '');
    if (country && !readManual()) apply(chooseLanguage(config.current, available, null, country, browserLanguage));
  }).catch(function () { /* Keep the current language if detection is unavailable. */ })
    .finally(function () { scope.clearTimeout(timeout); });
})(window);
